module.exports = __webpack_public_path__ + "img/IMG_8967.97815fd8.jpg";